import { render, staticRenderFns } from "./StyleOption.vue?vue&type=template&id=5c5a34f1&scoped=true"
import script from "./StyleOption.vue?vue&type=script&lang=js"
export * from "./StyleOption.vue?vue&type=script&lang=js"
import style0 from "./StyleOption.vue?vue&type=style&index=0&id=5c5a34f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5a34f1",
  null
  
)

export default component.exports